/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
import React, { useEffect, useState } from 'react';
import { Field, Form } from 'formik';
import { Badge, Button, Col, Label, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT, dynamicButtonHeading } from 'utils/constants';
import FormikInputField from 'components/Fields/FormikInputField';
import CardWithTitle from 'components/CardWithTitle';
import RolesField from 'components/RolesField';
import PermissionField from 'components/PermissionField';
import CallingCodeField from 'components/CallingCodeField';
import LoadingButton from 'components/common/LoadingButton';
import EmailFieldWithValidation from './EmailFieldWithValidation';
import PhoneNumberFieldWithValidation from './PhoneNumberFieldWithValidation';
import AllocateVendors from './AllocateVendors';

const AddEditStaffForm = (props) => {
  const {
    handleSubmit,
    drawerToggle,
    isSubmitting,
    dirty,
    isValid,
    type,
    ...rest
    // setErrors,
  } = props;
  const [userExists, setUserExists] = useState(false);
  const [filteredRM, setFilteredRM] = useState([]);

  useEffect(() => {
    const val = rest?.values?.roles?.filter(
      (rle) => rle?.name === 'SALES_EXECUTIVE' || rle?.name === 'SALES_HEAD',
    );
    if (!val.length) rest.setFieldValue('assignedTraders', []);
    setFilteredRM(val);
  }, [rest?.values?.roles]);

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="Personal Details">
        <Row>
          <Col sm={5}>
            <EmailFieldWithValidation
              label="Email"
              name="email"
              type="email"
              // setUserExists={setUserExists}
              disabled={dynamicButtonHeading(type) === 'Update' ? true : false}
              // callback=
              {...rest}
            />
          </Col>
          <Col sm={5}>
            <Field
              label="First Name"
              name="firstName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Middle Name (Optional)"
              name="middleName"
              type="text"
              component={FormikInputField}
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Last Name"
              name="lastName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>

          <Col sm={5}>
            <Label
              className={
                dynamicButtonHeading(type) === 'Update' ? 'disabled' : ''
              }
            >
              Phone Number<span className="text-danger">*</span>
            </Label>
            <Row className="flex-nowrap">
              <CallingCodeField
                id="callingCode"
                name="callingCode"
                label=""
                disabled={
                  dynamicButtonHeading(type) === 'Update' ? true : false
                }
              />
              <Col className="w-100">
                {/* <Field
                  label=""
                  name="phone"
                  type="text"
                  component={FormikInputField}
                  disabled={
                    rest?.values?.callingCode?.callingCode ? false : true
                  }
                /> */}
                <PhoneNumberFieldWithValidation
                  id="phone"
                  name="phone"
                  label=""
                  type="text"
                  placeholder="Phone number"
                  setUserExists={setUserExists}
                  disabled={
                    dynamicButtonHeading(type) === 'Update' ? true : false
                  }
                  {...rest}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </CardWithTitle>
      {/* <CardWithTitle title="Identification">
        <Field
          label="Aadhaar Front Page"
          name="aadhaarfrontpage"
          type="file"
          component={FormikInputField}
          accept="image/*,.pdf"
        />

        <Field
          label="Aadhaar Front Page"
          name="aadhaarfrontpage1"
          type="file"
          component={FormikInputField}
          accept="image/*,.pdf"
        />

        <Field
          label="Pancard"
          name="pancard"
          type="file"
          component={FormikInputField}
          accept="image/*,.pdf"
        />
      </CardWithTitle> */}
      <CardWithTitle title="Department">
        <Row>
          <Col sm={5}>
            <RolesField
              isMulti
              name="roles"
              label="Roles"
              type="select"
              required
            />
            {/* <Field
              label="Department"
              name="department"
              type="select"
              component={FormikSelectField}
              options={[
                { id: 1, label: 'department1' },
                { id: 2, label: 'department2' },
              ]}
              defaultoption="Select"
              keys={{ id: 'id', label: 'label' }}
            /> */}
          </Col>
          <Col sm={5}>
            <PermissionField isMulti roles={rest?.values?.roles || []} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {dynamicButtonHeading(type) === 'Update' ? (
              <div className="mb-2">
                <Label className="label-color text-nowrap mb-1">
                  Current permissions
                </Label>
                <br />
                {rest?.values?.permissions?.map((permission) => {
                  return (
                    <Badge
                      key={permission.name}
                      size="s"
                      className="me-1 text-dark fw-semibold"
                      color="light"
                    >
                      {permission.permissionName}
                    </Badge>
                  );
                })}
              </div>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </CardWithTitle>
      {filteredRM?.length > 0 && <AllocateVendors rest={rest} />}

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting || userExists}
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditStaffForm;
